<template>
  <div
    class="d-flex pa-2 flex-row flex-wrap"
    :style="{ height: 'fit-content' }"
  >
    <card-row :title="'Search'" :cardColor="'white'" :displayed="true">
      <div style="width: 100%">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-dialog
              ref="rangeDateDialog"
              v-model="rangeDateDialog"
              :return-value.sync="searchData.createdDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  id="rangeDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="dateRangeText"
                  label="Created At"
                  hide-details="true"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchData.createdDate"
                scrollable
                range
                :min="minDate"
                :max="maxDate"
              >
                <v-spacer></v-spacer>
                <v-btn text color="accent" @click="rangeDateDialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="accent"
                  @click="
                    () => {
                      checkRangeDate(searchData.createdDate);
                      $refs.rangeDateDialog.save(searchData.createdDate);
                    }
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="searchData.userRole"
              :items="listUserRole"
              label="Role User"
              clearable
              hide-details="true"
              :loading="loadingRole"
              dense
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              id="merchants"
              ref="merchants"
              :search-input.sync="searchMerchant"
              v-model="searchData.merchantId"
              :items="merchantList"
              hide-selected
              label="MID"
              persistent-hint
              item-value="merchantId"
              item-text="merchantId"
              :loading="loadingMerchant"
              hint="Search by MID"
              clearable
              dense
            >
              <template v-slot:item="{ item }">
                {{ item.merchantId + ' - ' + item.merchantName }}
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="d-flex align-center justify-left">
          <v-col cols="12">
            <v-btn @click="clearSearch"> Reset </v-btn>
            <v-btn
              color="primary"
              class="ml-2"
              @click.stop="getData"
              :loading="loading"
              >show</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </card-row>
  </div>
</template>

<script>
import { dataMinRangeDate, dataMaxRangeDate } from '../../store/params';
import { getDate, date } from '../../lib/helpers';

export default {
  components: { CardRow: () => import('../CardRow.vue') },
  props: ['search', 'loading'],
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    loadingRole: false,
    loadingMerchant: false,
    rangeDateDialog: false,
    searchMerchant: '',
    mId: null,
  }),
  mounted() {
    this.getRole();
  },
  watch: {
    searchMerchant(val) {
      if (val && val.length >= 3) {
        this.mId = val;
        this.getMerchant();
      } else {
        this.mId = '';
        this.$store.commit('userMerchant/clearMerchant');
      }
    },
  },
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    dateRangeText() {
      return this.searchData.createdDate.join(' ~ ');
    },
    merchantList() {
      return this.$store.state.userMerchant.merchantList;
    },
    listUserRole() {
      return this.$store.state.userMerchant.listUserRole;
    },
    minDate() {
      if (this.searchData.createdDate.length > 0) {
        const tempMinDate = Date.parse(this.searchData.createdDate[0]);
        return this.getDate(dataMinRangeDate, tempMinDate);
      }
      return '';
    },
    maxDate() {
      if (this.searchData.createdDate.length > 0) {
        const tempMaxDate = Date.parse(this.searchData.createdDate[0]);
        const maxDate = this.getDate(dataMaxRangeDate, tempMaxDate);
        return maxDate > this.today ? this.today : maxDate;
      }
      return this.today;
    },
  },
  methods: {
    getRole() {
      this.loadingRole = true;
      this.$store.commit('userMerchant/setFlashErrorMessage', '');
      this.$store
        .dispatch('userMerchant/getRole', {
          date,
        })
        .then(() => {
          this.loadingRole = false;
        });
    },
    getMerchant() {
      this.loadingMerchant = true;
      this.$store.commit('userMerchant/setFlashErrorMessage', '');
      this.$store
        .dispatch('userMerchant/getMerchant', {
          date,
          sortBy: 'ID',
          search: { merchantId: this.mId },
        })
        .then(() => {
          this.loadingMerchant = false;
        });
    },

    checkRangeDate(createdDate) {
      createdDate.sort();
      if (createdDate.length == 1) {
        createdDate.push(this.searchData.createdDate[0]);
      }
    },

    clearSearch() {
      this.$emit('clearSearchParent');
    },

    getData() {
      this.$emit('getDataParent');
    },
    getDate,
  },
};
</script>
